import React, {useState, useEffect} from 'react';
import { useTranslation } from "react-i18next";
import {makeStyles} from '@mui/styles';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import "leaflet-editable";
import Card from "@mui/material/Card";
import {ListItemButton} from "@mui/material";
import List from "@mui/material/List";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import {useHistory} from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {ClockPicker} from "@mui/x-date-pickers/ClockPicker";
import Grid from "@mui/material/Grid";
import dateFormat from "dateformat";
import DeliveryLocationDialog from "../DeliveryLocationDialog";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar";
import {httpClient} from "../../core/HttpClient";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

const useStyles = makeStyles((theme) => ({
    root: {},
    list: {
        paddingTop: 0
    },
    listSection: {
        backgroundColor: 'inherit',
    },
    ul: {
        backgroundColor: 'inherit',
        padding: 0,
    },
    tabs: {
        borderBottom: '1px solid #e8e8e8',

    },
    tabPanels: {
        '& .MuiBox-root': {
            padding: '0px',
        },
    },
}));


let TIME_INDEX = -1;

export default function Deliver() {
    const { t } = useTranslation();
    const classes = useStyles();
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [account, setAccount] = useState({zoom: 15,
        deliveryStartPrice: 0,
        deliveryAdditionalPrice: 0,
        deliveryStartAt: 1,
        deliveryAdditionalAt: 1,
        deliveryPostpaid: false,
        deliveryQrPayment: false,
        deliveryFundsTransfer: false,
        delivery: false,
        pickup: false,
        parcel: false,
        orderingType: '',
        orderingAcceptation: 'accept',
        deliveryType: 'immediately',
        deliveryDays: [],
        deliveryTimes: [],
        deliveryAreasSize: 0,
        times: [{weekdays: []}]
    });
    const [errors, setErrors] = useState([]);
    const [deliveryError, setDeliveryError] = useState(0);
    const [open, setOpen] = React.useState(false);
    const [openDeliveryLocation, setOpenDeliveryLocation] = useState(false);
    const [time, setTime] = useState(new Date(new Date().setHours(0, 0)));
    const [maxAreas, setMaxAreas] = useState(0);

    console.log('Deliver');

    useEffect(() => {
        console.log('[Deliver]');
        const fields = "cid,orderingType,lat,lng,zoom,deliveryStartPrice,deliveryAdditionalPrice,deliveryStartAt,deliveryAdditionalAt," +
            "delivery,pickup,parcel,orderingAcceptation,deliveryType,deliveryDays,deliveryTimes,deliveryAreas,deliveryAreasSize," +
            "deliveryPostpaid,deliveryQrPayment,deliveryFundsTransfer,times";
        const url = process.env.REACT_APP_API_BASE_URL + '/accounts/me?fields='+fields;
        // const paymentUrl = process.env.REACT_APP_API_BASE_URL + '/payments';
        let tasks = [
            httpClient.get(url),
            // httpClient.get(paymentUrl),
            httpClient.get(process.env.REACT_APP_API_BASE_URL + '/accounts/me/limited')
        ];
        Promise.all(tasks)
            .then(rs=>{
                if(rs[0] && rs[0].data){
                    setAccount(rs[0].data);
                }
                if(rs[1] && rs[1].data){
                    setMaxAreas(rs[1].data.areas);
                }
                setLoading(false);
            });
    }, []);

    const handleClick = (key) => () => {
        history.push('/deliver/' + key);
    };

    const handleAddRound = (e) => {
        const data = {hour: time.getHours(), minute: time.getMinutes()};
        // validate duplicate
        let duplicateResult = false;
        let duplicateIndex = -1;
        let _hourStr = ''+data.hour;
        let _minuteStr = ''+data.minute;
        account.deliveryTimes.forEach((dt,index)=>{
            if(''+dt.hour === _hourStr && ''+dt.minute === _minuteStr){
                duplicateResult = true;
                duplicateIndex = index;
            }
        });
        if(TIME_INDEX < 0){
            // add
            if(duplicateResult){
                setDeliveryError(1);
            } else {
                account.deliveryTimes.push(data);
            }
        } else {
            // edit
            if(duplicateResult && TIME_INDEX !== duplicateIndex){
                setDeliveryError(1);
            } else {
                account.deliveryTimes[TIME_INDEX] = data;
            }
        }
        let _deliveryTimes = account.deliveryTimes.sort((a, b) => ((parseInt(a.hour)*60)+parseInt(a.minute)) > ((parseInt(b.hour)*60)+parseInt(b.minute)) ? 1 : -1);
        setAccount({...account, deliveryTimes: _deliveryTimes});
        let _errors = errors;
        _errors.splice(_errors.indexOf('times'), 1);
        setErrors(_errors);
        setOpen(false);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleCloseDeliveryTimeError = () => {
        setDeliveryError(0);
    };

    const handleCloseDeliveryLocation = () => {
        setOpenDeliveryLocation(false);
    };

    const handleSaveDeliveryLocation = (deliveryAreas, deliveryAreasSize) => {
        if(deliveryAreas && deliveryAreas.length > 2 && deliveryAreasSize){
            setAccount({ ...account, deliveryAreas: [deliveryAreas], deliveryAreasSize: deliveryAreasSize});
        }
        setOpenDeliveryLocation(false);
    };

    return (
        <div className={classes.root}>
            <Box m={1}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                    <Typography variant="h6">
                        {t('deliver.method')}
                    </Typography>
                </Box>
            </Box>
            <Divider style={{'marginBottom': '10px', 'marginTop': '10px'}} />
            {loading &&
                <Box display="flex" justifyContent="center" mt={4}>
                    <CircularProgress size={20}/>
                </Box>
            }
            {!loading &&
                <Box m={1}>
                    <Card variant="outlined">
                        <List className={classes.root}>
                            <ListItemButton divider key="pickup" role={undefined} onClick={handleClick('pickup')}>
                                <ListItemIcon>
                                    <ShoppingBagIcon />
                                </ListItemIcon>
                                <ListItemText id='pickup'>
                                    <Box mr={1}>
                                        <Typography variant="h6">
                                            <div>
                                                {t('deliver.pickup')}
                                            </div>
                                            <div style={{fontSize: '1rem'}}>
                                                {t('deliver.pickupDescription')}
                                            </div>
                                        </Typography>
                                    </Box>
                                </ListItemText>
                                <ListItemSecondaryAction onClick={handleClick('pickup')}>
                                    <FiberManualRecordIcon color={account.pickup?'primary':'disabled'} />
                                </ListItemSecondaryAction>
                            </ListItemButton>
                            {/*<ListItemButton divider key="parcel" role={undefined} onClick={handleClick('parcel')}>*/}
                            {/*    <ListItemIcon>*/}
                            {/*        <LocalShippingIcon />*/}
                            {/*    </ListItemIcon>*/}
                            {/*    <ListItemText id='parcel'>*/}
                            {/*        <Box mr={1}>*/}
                            {/*            <Typography variant="h6">*/}
                            {/*                <div>*/}
                            {/*                    {t('deliver.parcel')}*/}
                            {/*                </div>*/}
                            {/*                <div style={{fontSize: '1rem'}}>*/}
                            {/*                    {t('deliver.parcelDescription')}*/}
                            {/*                </div>*/}
                            {/*            </Typography>*/}
                            {/*        </Box>*/}
                            {/*    </ListItemText>*/}
                            {/*    <ListItemSecondaryAction onClick={handleClick('parcel')}>*/}
                            {/*        <FiberManualRecordIcon color={account.parcel?'primary':'disabled'} />*/}
                            {/*    </ListItemSecondaryAction>*/}
                            {/*</ListItemButton>*/}
                            <ListItemButton key="delivery" role={undefined} onClick={handleClick('delivery')}>
                                <ListItemIcon>
                                    <DeliveryDiningIcon />
                                </ListItemIcon>
                                <ListItemText id='delivery'>
                                    <Box mr={1}>
                                        <Typography variant="h6">
                                            <div>
                                                {t('deliver.selfDelivery')}
                                            </div>
                                            <div style={{fontSize: '1rem'}}>
                                                {t('deliver.selfDeliveryDescription')}
                                            </div>
                                        </Typography>
                                    </Box>
                                </ListItemText>
                                <ListItemSecondaryAction onClick={handleClick('delivery')}>
                                    <FiberManualRecordIcon color={account.delivery?'primary':'disabled'} />
                                </ListItemSecondaryAction>
                            </ListItemButton>
                        </List>
                    </Card>
                </Box>
            }
            <Dialog
                onClose={ handleClose }
                maxWidth='xs'
                scroll="body"
                PaperProps={{
                    style: {
                        margin: 0,
                        maxWidth: 'none',
                    },
                }}
                open={ open }>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <ClockPicker date={time} onChange={(newDate) => setTime(newDate)} />
                </LocalizationProvider>
                <DialogActions>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Button onClick={ handleAddRound } fullWidth color='primary' variant="outlined"
                                    size="large">
                                { dateFormat(time, "HH:MM")}
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Button onClick={ handleClose } fullWidth variant="outlined"
                                    size="large">
                                {t('common.cancel')}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
            <DeliveryLocationDialog
                open={openDeliveryLocation}
                shop={account}
                maxAreas={maxAreas}
                onClose={handleCloseDeliveryLocation}
                onSave={handleSaveDeliveryLocation}
            />
            <Snackbar open={deliveryError>0}
                      anchorOrigin={{vertical:'top', horizontal:'center'}}
                      autoHideDuration={3000} onClose={handleCloseDeliveryTimeError}>
                <Alert onClose={handleCloseDeliveryTimeError} severity="warning">
                    {deliveryError === 1 && t('deliver.deliveryTimesDuplicate')}
                    {deliveryError === 2 && t('deliver.deliveryDatesRequire')}
                </Alert>
            </Snackbar>
        </div>
    )
}